const read = (key, fallback) => {
    try { return JSON.parse(localStorage.getItem(key) ?? 'null') ?? fallback; }
    catch { return fallback; }
};
const write = (key, val) => { try { localStorage.setItem(key, JSON.stringify(val)); } catch {} };

// ── Watch history ────────────────────────────────────────────────────
export const getHistory = () => read('hb_history', []);

export const addToHistory = (video) => {
    const { id, title, poster_url, duration } = video;
    const history = getHistory().filter(h => h.videoId !== id);
    history.unshift({
        videoId: id,
        title,
        poster_url,
        duration,
        progress: 0,
        lastWatched: new Date().toISOString(),
    });
    if (history.length > 50) history.splice(50);
    write('hb_history', history);
};

export const updateHistoryProgress = (videoId, progress) => {
    const history = getHistory();
    const item = history.find(h => h.videoId === videoId);
    if (item) {
        item.progress = progress;
        item.lastWatched = new Date().toISOString();
        write('hb_history', history);
    }
};

export const removeFromHistory = (videoId) => {
    write('hb_history', getHistory().filter(h => h.videoId !== videoId));
};

// ── Saved (bookmarks) ────────────────────────────────────────────────
export const getSaved = () => read('hb_saved', []);

export const isSaved = (videoId) => getSaved().includes(Number(videoId));

export const toggleSaved = (videoId) => {
    const saved = getSaved();
    const id    = Number(videoId);
    const idx   = saved.indexOf(id);
    if (idx === -1) saved.push(id); else saved.splice(idx, 1);
    write('hb_saved', saved);
    return idx === -1;
};

// ── Likes ────────────────────────────────────────────────────────────
export const getLikes = () => read('hb_likes', []);

export const isLiked = (videoId) => getLikes().includes(Number(videoId));

export const toggleLike = (videoId) => {
    const likes = getLikes();
    const id    = Number(videoId);
    const idx   = likes.indexOf(id);
    if (idx === -1) likes.push(id); else likes.splice(idx, 1);
    write('hb_likes', likes);
    return idx === -1;
};

// ── Collections ──────────────────────────────────────────────────────
export const getCollections = () => read('hb_collections', []);

export const createCollection = (name) => {
    const cols = getCollections();
    cols.push({ id: Date.now(), name, videoIds: [], createdAt: new Date().toISOString() });
    write('hb_collections', cols);
};

export const addVideoToCollection = (colId, videoId) => {
    const cols = getCollections();
    const col  = cols.find(c => c.id === colId);
    if (col && !col.videoIds.includes(videoId)) {
        col.videoIds.push(videoId);
        write('hb_collections', cols);
    }
};

export const deleteCollection = (colId) => {
    write('hb_collections', getCollections().filter(c => c.id !== colId));
};

// ── Tag subscriptions ────────────────────────────────────────────────
export const getSubscriptions = () => read('hb_subs', []);

export const isSubscribed = (tag) => getSubscriptions().includes(tag);

export const toggleSubscription = (tag) => {
    const subs = getSubscriptions();
    const idx  = subs.indexOf(tag);
    if (idx === -1) subs.push(tag); else subs.splice(idx, 1);
    write('hb_subs', subs);
    return idx === -1;
};

// ── Recent searches ──────────────────────────────────────────────────
export const getRecentSearches = () => read('hb_recent_searches', []);

export const addRecentSearch = (q) => {
    const searches = getRecentSearches().filter(s => s !== q);
    searches.unshift(q);
    if (searches.length > 10) searches.splice(10);
    write('hb_recent_searches', searches);
};

export const clearRecentSearches = () => write('hb_recent_searches', []);
